module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Signature Color and Thickness</span></div>\r\n</div>\r\n<div class=\"row\">\r\n	<div class=\"col-md-6\">\r\n		<input id=\"signatureColorPicker\" name=\"signatureColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( signatureColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n        <input id=\"signatureColor\" name=\"signatureColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( signatureColor ))
    ; __append("\" />\r\n	</div>\r\n	<div class=\"col-md-6 subsection nopadding-r\">\r\n		<label class=\"prop-sublabel\" style=\"width: 21px;\">Size</label> \r\n		<div class=\"label-40\">\r\n			<input type=\"number\" name=\"signatureThickness\" value=\"")
    ; __append(escapeFn(signatureThickness))
    ; __append("\" min=\"1\" max=\"100\" class=\"label-40\"/>\r\n		</div>\r\n	</div>\r\n</div>\r\n\r\n")
  }
  return __output;

}